/** @format */

import React from 'react'
import styled from 'styled-components'
import { numberFormat } from 'src/utils/common'
import variable from 'src/static/styles/var'

export interface ShareBarProps {
  className?: string
  /** 0–1 占比 */
  share?: number | null
}

const ShareBar: React.FC<ShareBarProps> = ({ className, share }) => {
  const sharePercent = Math.min(100, Math.max(0, (share ?? 0) * 100))
  return (
    <div className={className}>
      <div className="share-bar__track">
        <div className="share-bar__inner" style={{ width: `${sharePercent}%` }} />
      </div>
      <span className="share-bar__label">{numberFormat(sharePercent)}%</span>
    </div>
  )
}

export default styled(ShareBar)`
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 120px;

  .share-bar__track {
    flex: 1;
    height: 8px;
    overflow: hidden;
    border-radius: 4px;
    background: ${variable.greyBackground};
  }

  .share-bar__inner {
    height: 100%;
    border-radius: 4px;
    background: ${variable.primaryColor};
    transition: width 0.2s ease;
  }

  .share-bar__label {
    flex-shrink: 0;
    min-width: 42px;
    font-size: 12px;
    line-height: 18px;
    color: ${variable.fontColor};
    text-align: right;
  }
`
